const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20drama%20series%20promotional%20banner%20style%20with%20warm%20golden%20and%20orange%20tones%2C%20epic%20scale%2C%20dramatic%20composition%2C%20Chinese%20TV%20drama%20aesthetic%2C%20professional%20cinematic%20photography&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '本周焦点',
    title: '红桃视频年度大剧 · 口碑爆款不容错过',
    desc: '豆瓣高分热剧持续霸榜，全网点播量突破10亿，剧情、演技、制作全方位在线',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20series%20promotional%20banner%20with%20dark%20warm%20amber%20lighting%2C%20suspenseful%20mood%2C%20cinematic%20atmosphere%2C%20Chinese%20drama%20aesthetic%2C%20professional%20photography&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '悬疑专场',
    title: '樱桃视频悬疑剧场 · 全程高能烧脑不断',
    desc: '精选年度口碑悬疑剧，剧情层层递进反转不停，悬疑爱好者必看合集',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20trendy%20short%20drama%20series%20promotional%20banner%20with%20vibrant%20warm%20colors%2C%20youthful%20energy%2C%20modern%20urban%20style%2C%20Chinese%20entertainment%20aesthetic%2C%20professional%20photography&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '短剧精选',
    title: '茄子视频短剧合集 · 碎片时间追剧神器',
    desc: '每集10分钟短小精悍，剧情紧凑节奏明快，上班通勤、午休摸鱼最佳拍档',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20variety%20show%20promotional%20banner%20with%20bright%20cheerful%20warm%20lighting%2C%20entertainment%20atmosphere%2C%20colorful%20vibrant%20composition%2C%20Chinese%20TV%20show%20aesthetic%2C%20professional%20photography&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '综艺推荐',
    title: '糖心视频综艺大盘点 · 欢乐周末指南',
    desc: '搞笑综艺、竞技挑战、明星访谈一网打尽，承包你整个周末的快乐源泉',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20historical%20costume%20drama%20promotional%20banner%20with%20elegant%20warm%20amber%20golden%20tones%2C%20traditional%20Chinese%20aesthetic%2C%20cinematic%20epic%20scale%2C%20professional%20photography&width=1200&height=600&seq=carousel-05&orientation=landscape',
    tag: '古风大赏',
    title: '全网古装剧年度精选 · 国风美学盛宴',
    desc: '汇集红桃、樱桃各大平台古装佳作，服化道精致剧情荡气回肠，视觉与故事的双重享受',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            精选优质内容专题，发现更多精彩
          </p>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="flex-shrink-0 w-[85vw] max-w-[640px] snap-start group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="inline-block text-xs font-semibold px-3 py-1 rounded-full bg-accent-100 text-accent-700 mb-3 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-extrabold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}